/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientInfosResource
 */
export interface ClientInfosResource {
    /**
     * 
     * @type {string}
     * @memberof ClientInfosResource
     */
    currencyCode: string;
    /**
     * Client fees applied to project in percentage from 0 to 100
     * @type {number}
     * @memberof ClientInfosResource
     */
    feesPercentage: number;
    /**
     * Is the company allowed to use the client facing repatriation feature
     * @type {boolean}
     * @memberof ClientInfosResource
     */
    repatriationAllowed: boolean;
    /**
     * If we already have the phone number of the client
     * @type {boolean}
     * @memberof ClientInfosResource
     */
    phoneNumberKnown: boolean;
    /**
     * If the user is allowed to skip the step where we ask their phone number
     * @type {boolean}
     * @memberof ClientInfosResource
     */
    canSkipPhoneNumberStep: boolean;
    /**
     * Whether the client's legal entity has an agency mirror contract configured, enabling agency invitations
     * @type {boolean}
     * @memberof ClientInfosResource
     */
    canInviteAgencies: boolean;
}

/**
 * Check if a given object implements the ClientInfosResource interface.
 */
export function instanceOfClientInfosResource(value: object): value is ClientInfosResource {
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    if (!('feesPercentage' in value) || value['feesPercentage'] === undefined) return false;
    if (!('repatriationAllowed' in value) || value['repatriationAllowed'] === undefined) return false;
    if (!('phoneNumberKnown' in value) || value['phoneNumberKnown'] === undefined) return false;
    if (!('canSkipPhoneNumberStep' in value) || value['canSkipPhoneNumberStep'] === undefined) return false;
    if (!('canInviteAgencies' in value) || value['canInviteAgencies'] === undefined) return false;
    return true;
}

export function ClientInfosResourceFromJSON(json: any): ClientInfosResource {
    return ClientInfosResourceFromJSONTyped(json, false);
}

export function ClientInfosResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientInfosResource {
    if (json == null) {
        return json;
    }
    return {
        
        'currencyCode': json['currencyCode'],
        'feesPercentage': json['feesPercentage'],
        'repatriationAllowed': json['repatriationAllowed'],
        'phoneNumberKnown': json['phoneNumberKnown'],
        'canSkipPhoneNumberStep': json['canSkipPhoneNumberStep'],
        'canInviteAgencies': json['canInviteAgencies'],
    };
}

export function ClientInfosResourceToJSON(value?: ClientInfosResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'currencyCode': value['currencyCode'],
        'feesPercentage': value['feesPercentage'],
        'repatriationAllowed': value['repatriationAllowed'],
        'phoneNumberKnown': value['phoneNumberKnown'],
        'canSkipPhoneNumberStep': value['canSkipPhoneNumberStep'],
        'canInviteAgencies': value['canInviteAgencies'],
    };
}

